import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AuthGuard } from '@acepteam/globalspack';

const routes: Routes = [

  //lazy loaded
  {
    path: 'group',
    loadChildren: () =>
      import('./groupportal/groupportal.module').then(m => m.GroupPortalModule)
  },
  {
    path: 'groupsearch',
    loadChildren: () =>
      import('./group-search/group-search.module').then(m => m.GroupSearchModule)
  },
  {
    path: "",
    redirectTo: "group",
    pathMatch: "full"
  },
  {
    path: "**",
    redirectTo: "group"
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', useHash: true, enableTracing: false, preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
